(function ($, Drupal, once) {

  'use strict';

  const header = document.querySelector('.header');

  if (!header) return;

  const menu = header.querySelector('.js-main-menu');

  const landingHeaderHeightInRem = 120 / 16;

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.header = {
    /**
     * Roll the header above the screen.
     */
    hide: function () {
      header.classList.add('header-hide');
      Promutuel.topnavStoreLocator?.hide();
    },

    /**
     * Get the header back on screen.
     */
    show: function () {
      header.classList.remove('header-hide');
    },

    /**
     * Open or close the main menu for small displays (mobile).
     */
    toggleMobileMenu: function () {
      if (Promutuel.responsive?.getCurrentSize() >= Promutuel.responsive?.BREAKPOINTS.LG) return;

      document.body.classList.toggle('overflow-hidden'); // Freeze content to prevent scrolling.
      $('.js-header-mobile-menu').slideToggle(200);
      header.querySelector('.js-header-toggle').classList.toggle('open');

      header.style.setProperty(
        '--header-menu-height',
        `${menu.offsetHeight}px`
      );
    },
    openMobileMenu: function () {
      if (header.querySelector('.js-header-toggle').classList.contains('open')) return;
      this.toggleMobileMenu();
    },
    closeMobileMenu: function () {
      if (!header.querySelector('.js-header-toggle').classList.contains('open')) return;
      this.toggleMobileMenu();
    },
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_header = {
    attach: function attach(context) {
      $(once('promutuelHeader', '.header', context)).each(function () {
        // Ugly timeout trick. so the computation is done after all the admin
        // toolbar initialization is done.
        setTimeout(positionHeaderBelowAdminToolbar, 100);

        //Hamburger menu
        $('.header .js-header-toggle').on('click keypress', function(){
          Promutuel.header.toggleMobileMenu();
        });

        // Viewport scroll management
        {
          let lastScrollTop = 0;
          const onLandingPage = header.classList.contains('header--landing');

          $(window).scroll(function(event){
            const scrollTop = $(this).scrollTop();
            const minTrigger = onLandingPage
                             ? remToPx(landingHeaderHeightInRem / 2)
                             : header.offsetHeight;

            // Scrolling down
            if (scrollTop > lastScrollTop) {
              // Don't roll up before we've reached the height of the header,
              // to avoid revealing the pading zone below.
              if (scrollTop > minTrigger) Promutuel.header.hide();
            }
            // Scrolling up
            else {
              Promutuel.header.show();
            }

            lastScrollTop = scrollTop;

            // Landing page special header with hero covering half of it.
            if (header.classList.contains('header--landing')) {
              const cover = document.querySelector('.js-header-cover');

              // Hide the cover and reduce the header after half the bar height.
              if (scrollTop > minTrigger) {
                cover?.classList.add('d-all-none');
                header.style.setProperty(
                  '--header-bar-height',
                  `${landingHeaderHeightInRem/2}rem`
                );
                header.classList.add('header--landing__scroll');
              }
              else {
                cover?.classList.remove('d-all-none');
                header.style.removeProperty('--header-bar-height');
                header.classList.remove('header--landing__scroll');
              }
            }
          });
        }
      });
    }
  };

  /**
   * Move language switcher link into top menu.
   * @type {{attach: Drupal.behaviors.promutuel_language_switch.attach}}
   */
  Drupal.behaviors.promutuel_language_switch = {
    attach: function attach(context) {

      once('promutuelLanguageSwitch', '.header__top-navigation-container', context).forEach( () => {
        const languageSwitch = document.querySelectorAll('.block-language');
        if (languageSwitch !== null && languageSwitch.length > 0) {
          const link = languageSwitch[0].querySelector('.links li:not(.is-active)');
          const topMenu = document.querySelector('#block-promutuel-top-menu .menu');
          topMenu.appendChild(link);
        }
      });
    }
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Utilities
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  // Move the header down if the admin bar is displayed.
  function positionHeaderBelowAdminToolbar() {
    const adminToolbarHeight =
      (document.querySelector('#toolbar-bar')?.offsetHeight || 0)
      + (document.querySelector('.toolbar-tray-horizontal.is-active')?.offsetHeight || 0);

    if (adminToolbarHeight + 0) {
      document.documentElement.style.setProperty('--header-adminoffset', `${adminToolbarHeight}px`);
      // header.style.top = `${adminToolbarHeight}px`;
    }
  }

  function remToPx(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }
})(jQuery, Drupal, once);
